import { render, staticRenderFns } from "./record.vue?vue&type=template&id=c40978be&scoped=true"
import script from "./record.vue?vue&type=script&lang=js"
export * from "./record.vue?vue&type=script&lang=js"
import style0 from "./record.vue?vue&type=style&index=0&id=c40978be&prod&lang=less&scoped=true"
import style1 from "./record.vue?vue&type=style&index=1&id=c40978be&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c40978be",
  null
  
)

export default component.exports